module.exports = __webpack_public_path__ + "img/23.e32af86c.png";